import { useRoomCreateRoomMilestone, useRoomDeleteRoomMilestone } from "@crowdcoursing/api/openapi";

import { useToast } from "./useToast";

export const useRoomMilestoneManagement = (roomId: string, onSuccess?: () => void) => {
  const toast = useToast();

  const { mutateAsync: createMilestoneMutation, isPending: isCreating } = useRoomCreateRoomMilestone({
    onSuccess: () => {
      toast.success("Milestone created successfully!");
      onSuccess?.();
    },
  });

  const { mutateAsync: deleteMilestoneMutation, isPending: isDeleting } = useRoomDeleteRoomMilestone({
    onSuccess: () => {
      toast.success("Milestone deleted successfully!");
      onSuccess?.();
    },
  });

  const createMilestone = async (milestone: { name: string; description: string; dueDate: Date }) => {
    await createMilestoneMutation(
      {
        body: {
          description: milestone.description,
          dueDate: milestone.dueDate.toISOString(),
          name: milestone.name,
          roomId,
        },
        pathParams: {
          roomId,
        },
      },
      {
        onError: (error) => {
          console.error("Error creating milestone:", error);
          toast.error("Failed to create milestone. Please try again.");
        },
      },
    );
  };

  const deleteMilestone = async (milestone: { id: string }) => {
    await deleteMilestoneMutation(
      {
        pathParams: {
          milestoneId: milestone.id,
          roomId,
        },
      },
      {
        onError: (error) => {
          console.error("Error deleting milestone:", error);
          toast.error("Failed to delete milestone. Please try again.");
        },
      },
    );
  };

  return {
    completeMilestone: deleteMilestone,
    createMilestone,
    deleteMilestone,
    isCreating,
    isDeleting,
    isLoading: isCreating || isDeleting,
  };
};
